import { StoreProps } from '../store/login'
const selectLoading = (state: StoreProps) => state.loading
const selectSetLoading = (state: StoreProps) => state.setLoading
const selectors = {
  selectLoading,
  selectSetLoading,
}

export default selectors
